import { useTranslation } from "react-i18next";

import { useModal } from "../../hooks/useModal";
import { CustomButton } from "../CustomButton";
import { CustomModal } from "../CustomModal";

import styles from "./ModalPaidBeforeVisitRequired.module.scss";

export const ModalPaidBeforeVisitRequired: React.FC = () => {
  const { t } = useTranslation();
  const modal = useModal(true);

  return (
    <CustomModal
      title="modalPaidBeforeVisitRequired.title"
      isModalVisible={modal.isModalVisible}
      toggleModalVisibility={modal.toggleModalVisibility}
    >
      <p className={styles.text}>{t("modalPaidBeforeVisitRequired.text")}</p>
      <CustomButton onClick={modal.toggleModalVisibility} text={t("modalPaidBeforeVisitRequired.back")} fullWidth />
    </CustomModal>
  );
};
